import { gql } from "@apollo/client";
import useWrappedQuery from "../../common/data-fetching/useWrappedQuery";

const QUERY_SCOPE = "application";
const QUERY_NAME = "applicationValidate";

export const QUERY = gql`
  query ${QUERY_SCOPE}_${QUERY_NAME}($candidateId: ID, $jobId: ID, $recruiterId: ID!) {
    ${QUERY_SCOPE} {
      _id
      ${QUERY_NAME}(candidateId: $candidateId, jobId: $jobId, recruiterId: $recruiterId)
    }
  }
`;

export default function useQueryApplicationValidate(candidateId, jobId, recruiterId) {
  const variables = { candidateId, jobId, recruiterId };

  return useWrappedQuery(QUERY, QUERY_SCOPE, QUERY_NAME, {
    variables,
    // Get info from cache and ask the network at the same time, then update on response
    fetchPolicy: "network-only",
  });
}
